import store from "../store";
import { actionTypes } from "./saga";

export function updateCapturePicture(data, navigate) {
  store.dispatch({
    type: actionTypes.UPDATE_CAPTURE_PICTURE,
    payload: { data, navigate }
  });
}

export function revertUpdateCapturePicture(data, navigate) {
  store.dispatch({
    type: actionTypes.REVERT_CAPTURE_PICTURE,
    payload: { data, navigate }
  });
}
